export const toPentestReportDate = (
  nextPentestReportDate?: string | Date | null,
): Date | null =>
  nextPentestReportDate ? new Date(nextPentestReportDate) : null;

export const toPentestReportDateFieldValue = (
  date?: Date | string | null,
): string => {
  if (!date) {
    return '';
  }

  if (date instanceof Date) {
    return date.toISOString().split('T')[0];
  }

  return date.split('T')[0];
};
